import { QueryKeys } from '@/api/hooks/queryKeys.ts'
import { joinPath } from '@/util/core-functions.util'
import { ApiPaths } from '@/util/paths'
import type { EventView } from '@/util/views/event.view'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

export const useEventQuery = (path: string) => {
  return useQuery<EventView, Error>({
    queryKey: [QueryKeys.EVENTS, path],
    queryFn: async () => {
      const response = await axios.get<{ event: EventView }>(joinPath(ApiPaths.EVENTS, path))
      return response.data.event
    }
  })
}
